module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "autologin"
    }
  }, [_c('div', {
    staticClass: "autologin-page"
  }, [_c('div', {
    staticClass: "autologin-content"
  }, [_c('div', {
    staticClass: "infinite-loading-container"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v(" "), _c('div', [_vm._v("Loading")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("Please waiting for authentication.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46df2be1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/autologin/component.vue
// module id = 3728
// module chunks = 1